import { render, staticRenderFns } from "./ProductCategoryIcon.vue?vue&type=template&id=5576cc75&scoped=true"
import script from "./ProductCategoryIcon.vue?vue&type=script&lang=js"
export * from "./ProductCategoryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5576cc75",
  null
  
)

export default component.exports